import { BaseSignalr } from './signalr.js';
export class SignalrSell extends BaseSignalr {
    requestAchTxAddress(clientId, orderId) {
        console.log('invoke RequestAchTxAddress', clientId, orderId);
        return this.invoke('RequestAchTxAddress', {
            TargetClientId: clientId,
            OrderId: orderId,
        });
    }
    onAchTxAddressReceived({ orderId }, callback) {
        return this.listen('onAchTxAddressReceived', (data) => {
            var _a;
            if (((_a = data === null || data === void 0 ? void 0 : data.body) === null || _a === void 0 ? void 0 : _a.orderId) === orderId) {
                callback(data.body);
            }
            else {
                callback(null);
            }
        });
    }
    requestOrderTransferred(clientId, orderId) {
        console.log('invoke RequestOrderTransferred', clientId, orderId);
        return this.invoke('RequestOrderTransferred', {
            TargetClientId: clientId,
            OrderId: orderId,
        });
    }
    onRequestOrderTransferred({ orderId }, callback) {
        return this.listen('onOrderTransferredReceived', (data) => {
            var _a;
            if (((_a = data === null || data === void 0 ? void 0 : data.body) === null || _a === void 0 ? void 0 : _a.orderId) === orderId) {
                callback(data.body);
            }
            else {
                callback(null);
            }
        });
    }
    requestNFTOrderStatus(clientId, orderId) {
        console.log('invoke RequestNFTOrderStatus', clientId, orderId);
        return this.invoke('RequestNFTOrderStatus', {
            targetClientId: clientId,
            orderId: orderId,
        });
    }
    OnNFTOrderChanged({ orderId }, callback) {
        return this.listen('OnNFTOrderChanged', (data) => {
            var _a;
            console.log('OnNFTOrderChanged:', data, orderId);
            if (((_a = data === null || data === void 0 ? void 0 : data.body) === null || _a === void 0 ? void 0 : _a.orderId) === orderId) {
                callback(data.body);
            }
            else {
                callback(null);
            }
        });
    }
}
export const sellListenList = ['onAchTxAddressReceived', 'onOrderTransferredReceived', 'OnNFTOrderChanged'];
export const signalrSell = new SignalrSell({
    listenList: sellListenList,
});
